// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Sentry = require("../../reason/Sentry.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var PaymentForm__Jsx3 = require("../../uikit/reason/molecules/PaymentForm/PaymentForm__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SetAccountCardDialogMutation_graphql = require("../../__generated__/SetAccountCardDialogMutation_graphql.bs.js");

var convertVariables = SetAccountCardDialogMutation_graphql.Internal.convertVariables;

var convertResponse = SetAccountCardDialogMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = SetAccountCardDialogMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SetAccountCardDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, SetAccountCardDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function SetAccountCardDialog(props) {
  var __hasExistingCard = props.hasExistingCard;
  var closeDialog = props.closeDialog;
  var hasExistingCard = __hasExistingCard !== undefined ? __hasExistingCard : true;
  var match = use();
  var mutate = match[0];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(PaymentForm__Jsx3.Form.make, {
                      buttonText: (
                        hasExistingCard ? "UPDATE" : "ADD"
                      ) + " PAYMENT CARD",
                      onToken: (function (token) {
                          var token$1 = token.id;
                          return new Promise((function (resolve, param) {
                                        mutate({
                                              input: {
                                                token: token$1
                                              }
                                            }, undefined, undefined, undefined, (function (param, param$1) {
                                                var updatePaymentCard = param.updatePaymentCard;
                                                if (updatePaymentCard === undefined) {
                                                  return resolve({
                                                              NAME: "PaymentError",
                                                              VAL: "There was a problem updating your card"
                                                            });
                                                }
                                                if (updatePaymentCard.__typename !== "PaymentCardUpdated") {
                                                  return resolve({
                                                              NAME: "PaymentError",
                                                              VAL: "There was a problem updating your card"
                                                            });
                                                }
                                                resolve("Success");
                                                closeDialog();
                                              }), (function (e) {
                                                Sentry.captureErrorMessage(String(e), true, undefined, "SetAccountCardDialog.res", 39, undefined, undefined, undefined);
                                                resolve({
                                                      NAME: "PaymentError",
                                                      VAL: "There was a problem updating your card"
                                                    });
                                              }), undefined);
                                      }));
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                            onClick: (function (param) {
                                closeDialog();
                              }),
                            children: "Cancel"
                          }),
                      className: "pt-8 flex justify-center"
                    })
              ],
              className: "mt-2 md:mt-4"
            });
}

var PaymentForm;

var LinkButton;

var make = SetAccountCardDialog;

exports.PaymentForm = PaymentForm;
exports.LinkButton = LinkButton;
exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
